import { render } from "./WechatPaymentModal.vue?vue&type=template&id=1643a79c&scoped=true"
import script from "./WechatPaymentModal.vue?vue&type=script&lang=js"
export * from "./WechatPaymentModal.vue?vue&type=script&lang=js"

import "./WechatPaymentModal.vue?vue&type=style&index=0&id=1643a79c&scoped=true&lang=css"

import exportComponent from "D:\\projectLinkoffer\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1643a79c"]])

export default __exports__